import { Component, NgZone } from "@angular/core";
import { CommonService } from "../../services/common.service";
import { MsalService } from "@azure/msal-angular";
import { EventEmitterService } from "./../../services/event.emitter.services";
import { SubscriptionConstantService } from "./../../constants/subscription.constant.service";
import { environment } from "src/environments/environment";
import { ConstantService } from "../../constants/constant.service";
import * as moment from "moment-timezone";
import { Router, RouterLink } from "@angular/router";
import { NgIf, NgFor } from "@angular/common";
import { NgDynamicBreadcrumbModule } from "ng-dynamic-breadcrumb";
import { jwtDecode } from "jwt-decode";
@Component({
  selector: "app-top-bar",
  templateUrl: "./top-bar.component.html",
  standalone: true,
  imports: [NgIf, NgFor, NgDynamicBreadcrumbModule],
  providers: [SubscriptionConstantService],
})
export class TopBarComponent {
  public displayNotification = false;
  public toggleButtonStatus: any = localStorage.getItem("adminAction")
    ? localStorage.getItem("adminAction")
    : false;
  public toggleButtonProxyStatus: any = localStorage.getItem("proxyAction")
    ? localStorage.getItem("proxyAction")
    : false;  
  public loaderText = null;
  public screenType = null;
  public displayAdminActionMenu = false;
  public eventLogs: any[] = [];

  constructor(
    public EventEmitterService: EventEmitterService,
    public SubscriptionConstantService: SubscriptionConstantService,
    public constantService: ConstantService,
    public commonService: CommonService,
    private authService: MsalService,
    private router: Router,
    private ngZone: NgZone
  ) {
    this.EventEmitterService.psProjectUpdateMessage$.subscribe((subscriptionData: any) => {
      if (this.eventLogs.length === 20) {
        this.eventLogs.pop();
      }
      const obj: any = Object.assign({}, subscriptionData);
      obj["happenedAt"] = moment(new Date());
      this.eventLogs.unshift(obj);
    });

    /**
     * Event Emitter Subscribe Section - Display Progress Overlay
     */
    this.EventEmitterService.displayProgressMessage$.subscribe((displayProgress: any) => {
      if (displayProgress) {
        this.loaderText = displayProgress;
        this.SubscriptionConstantService.LOADER_STATUS = true;
      } else {
        this.SubscriptionConstantService.LOADER_STATUS = false;
      }
    });
    /**
     * Event Emitter Subscribe Section - Display Notification
     */
    this.EventEmitterService.displayNotificationMessage$.subscribe((displayNotification) => {
      const notificationData = displayNotification;
      this.displayNotification = environment.biDirectionalNotificationFlag;
      this.SubscriptionConstantService.SUCCESS_MESSAGE = notificationData.message;
      this.screenType = notificationData.type;
    });
  }
  logout() {
    this.authService.logout();
    localStorage.removeItem("currentUser");
    localStorage.removeItem("token");
    localStorage.removeItem("menuItems");
    localStorage.removeItem("userName");
    localStorage.removeItem("adminAction");
    localStorage.removeItem("proxyAction");
    localStorage.removeItem("previousUrl");
  }

  ngOnInit() {}

  public get versionMismatch() {
    return localStorage.getItem("versionMismatch") ? localStorage.getItem("versionMismatch") : null;
  }

  public get userName() {
    this.toggleButtonStatus =
      localStorage.getItem("adminAction") && localStorage.getItem("adminAction") == "true"
        ? "true"
        : "false";
    this.toggleButtonProxyStatus =
      localStorage.getItem("proxyAction") && localStorage.getItem("proxyAction") == "true"
        ? "true"
        : "false";
    return localStorage.getItem("userName") ? localStorage.getItem("userName") : null;
  }

  /**
   * Event emitter - Refresh Page
   */
  refresh() {
    this.displayNotification = false;
    this.ngZone.run(() => {
      this.EventEmitterService.refreshScreensSendMessage(this.screenType);
    });
  }

  toggleProxyAction(flag: any) {
    this.toggleButtonProxyStatus = flag ? "true" : "false";
    localStorage.setItem("proxyAction", this.toggleButtonProxyStatus);
    // this.EventEmitterService.toggleProxyActionSendMessage(this.toggleButtonProxyStatus);
  }

  toggleAdminAction(flag: any) {
    this.toggleButtonStatus = flag ? "true" : "false";
    localStorage.setItem("adminAction", this.toggleButtonStatus);
    this.EventEmitterService.toggleAdminActionSendMessage(this.toggleButtonStatus);
  }
  adminActionMenuDisplay() {
    const currentMenuItems = JSON.parse(localStorage.getItem("menuItems")!);
    let weightagess = 0;
    if (currentMenuItems) {
      for (let i = 0; i < currentMenuItems.length; i++) {
        if (currentMenuItems[i].menu && currentMenuItems[i].menu === "SO") {
          weightagess = currentMenuItems[i].weightage;
        }
      }
      if (weightagess > this.constantService.ADMIN_WEIGTAGE) {
        this.displayAdminActionMenu = true;
      }
    }
    return this.displayAdminActionMenu;
  }

  clearNotification() {
    this.eventLogs = [];
  }

  formateDateTime(date: any) {
    this.ngZone.run(() => {
      return moment(date).fromNow();
    });
  }
  public get fopcSnapshot(): any {
    const token: any = localStorage.getItem("token");
    if (token && this.router?.url) {
      const decoded: any = jwtDecode(token);
      const groups: string[] = decoded.groups || [];
      const isInFopcGroup = groups.includes(environment.ADMIN_GROUP_ID);
      return this.router.url === "/production-snapshot" && isInFopcGroup ? "true" : "false";
    }
  }
}
